import React, { useEffect, useState } from 'react';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { getTranslatedPlaceholder } from '../../utils';
import {ALL_SELECTED} from '../../constants';
/*source https://www.npmjs.com/package/react-multiselect-checkboxes*/

const MultipleSearchSelectionWrapper = props => {
  const [values, setValues] = useState(props.values);
  const [all, setAll] = useState(false);

  useEffect(() => {
  	setValues(props.values);
  }, [props.values]);

  const handleChange = (selectedOption, actionType) => {
    //on clear, force add the default values
    if (actionType !== 'clear')
      selectedOption.forEach(o => {
        let so = props.optionsList.find(so => so.value == o.value);
        if (so) o.label = so.label;
      });

    if (selectAll) {
      const isAllOptionSelected = selectedOption.some(
        o => o.value == ALL_SELECTED
      );
      if (!all && isAllOptionSelected) {
        selectedOption = optionsList;
        setAll(true);
      } else if (all && !isAllOptionSelected) {
        selectedOption = [];
        setAll(false);
      } else if (all && isAllOptionSelected) {
        selectedOption = selectedOption.filter(
          o => o.value != ALL_SELECTED
        );
        setAll(false);
      } else setAll(false);
    }

    props.onChange(selectedOption, actionType);
    setValues(selectedOption);
  };

  const selectAllOptionsItem = key => {
    return {
      label: props.selectAllLabel,
      value: ALL_SELECTED
    };
  };

  const customStyles = {
    option: (styles, state) => ({
      ...styles,
      borderTop: '1px solid #fafafa;',
      backgroundColor: state.isSelected ? 'rgba(0,0,0,.03)' : 'white',
      fontWeight: 'normal',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,.05)'
      }
    }),
    control: styles => ({
      ...styles,
      boxShadow: 0,
      padding: '0px',
      borderColor: 'rgba(34,36,38,.15)',
      '&:hover': {
        borderColor: 'rgba(34,36,38,.15)'
      }
    }),
    dropdownButton: styles => ({
      ...styles,
      height: '1.89em',
      width: '100%',
      padding: '1px 5px 1px 12px',
      boxShadow: props.inputClassName != null ? '0 0 0 3px rgba(0, 149, 255, 0.15)' : 0,
      border: 'solid 1px rgba(34,36,38,.15)',
      borderRadius: '.28571429rem'
    }),
    container: styles => ({
      ...styles,
      boxShadow: '0 2px 3px 0 rgba(34,36,38,.15)',
      border: 'solid 1px',
      borderColor: '#96c8da',
      marginTop: '-8px',
      backgroundColor: 'white'
    })
  };

  const { name, optionsList, t, label, placeholder, selectAll } = props;

  let optionsListTranslated = [];
  if (optionsList) {
    if (selectAll && !optionsList.some(o => o.value == ALL_SELECTED))
      optionsList.splice(0, 0, selectAllOptionsItem(name));
    optionsList.forEach(o => {
      optionsListTranslated.push(Object.assign({}, o, { label: t(o.label) }));
    });
  }

  let valuesTranslated = [];
  if (values)
    values.forEach(o => {
      valuesTranslated.push(Object.assign({}, o, { label: t(o.label) }));
    });

  return (
    <ReactMultiSelectCheckboxes
      id={name}
      name={name}
      styles={customStyles}
      value={valuesTranslated}
      options={optionsListTranslated}
      placeholderButtonLabel={getTranslatedPlaceholder(label, placeholder, t)}
      onChange={(selectedOption, actionType) => handleChange(selectedOption, actionType)}
    />
  );
};

MultipleSearchSelectionWrapper.propTypes = {
  optionsList: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  inputClassName: PropTypes.string
};

MultipleSearchSelectionWrapper.defaultProps = {
  name: '',
  inputClassName: null,
  placeholder: 'Select',
  selectAll: false,
  selectAllLabel: '[Select All]'
};

export default withTranslation()(MultipleSearchSelectionWrapper);
